/* eslint-disable no-template-curly-in-string */
import { yupResolver } from '@hookform/resolvers/yup'
import { Close } from '@mui/icons-material'
import {
  Alert,
  AlertTitle,
  CardActions,
  CardContent,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid
} from '@mui/material'
import {
  Button,
  Card,
  CardHeader,
  DatePickerC,
  IconButton,
  Modal,
  SelectC,
  TextFieldC
} from 'components'
import { FormProvider, useForm } from 'react-hook-form'
import { Yup, getTimezonedIsoString } from 'utils'
import { useTurnOrderStore } from './turnOrderStore'
import { useConfirmProposalData } from './useConfirmProposalData'
import { useEffect, useState } from 'react'
import Checkbox from '@mui/material/Checkbox'
import { useLoadConfirmProposalData } from './useLoadConfirmProposalData'
import { useTurnOrder } from 'modules/orders/hooks'
import { useAuth } from 'lib/auth'

type FormData = {
  deliveryDate: string | Date | null
  requestedDate: string | Date | null
  expeditionObs?: string
  scienceStatus: { id: string; name: string } | null
  expeditionRequired: number
}

const Label = ({ children }: any) => (
  <label style={{ fontWeight: 'bold' }}>{children}</label>
)

const schema = Yup.object({
  expeditionObs: Yup.string().test(
    'max-len',
    'deve ter no máximo 251 caracteres',
    (value) => (value ? value?.length < 252 : true)
  ),
  deliveryDate: Yup.string().required(),
  requestedDate: Yup.date().nullable(),
  scienceStatus: Yup.mixed().required()
})

export function TurnOrderModal() {
  const [dateChecked, setDateChecked] = useState(false)
  const [obsChecked, setObsChecked] = useState(false)
  const [scienceChecked, setScienceChecked] = useState(false)
  const isOpen = useTurnOrderStore.useIsModalOpen()
  const setIsOpenModal = useTurnOrderStore.useSetModalOpen()
  const proposalId = useTurnOrderStore.useProposalId()

  const { data: orderData } = useLoadConfirmProposalData({
    proposalId
  })

  const { user } = useAuth()

  console.log(user)

  const methods = useForm<FormData>({
    resolver: yupResolver(schema),
    defaultValues: {
      deliveryDate: null,
      requestedDate: null,
      expeditionObs: '',
      scienceStatus: null,
      expeditionRequired: 0
    }
  })

  const { handleSubmit, trigger, reset, getValues } = methods

  const { mutateAsync, isLoading } = useConfirmProposalData()
  const {
    mutateAsync: turnOrder,
    isLoading: loadingTurnOrder,
    error
  } = useTurnOrder()

  const isSintegraError = error?.response?.data?.message.includes(
    'sintegra-validation'
  )
  const sintegraError = isSintegraError
    ? JSON.parse(error?.response?.data?.message)
    : {}

  // console.log({ sintegraError, isSintegraError })

  const onClose = async () => {
    try {
      const data = getValues()

      const normalizedData = {
        proposalId,
        deliveryDate: dateChecked
          ? data?.deliveryDate
            ? new Date(data?.deliveryDate).toISOString()
            : null
          : null,
        requestedDate: data?.requestedDate
          ? new Date(data?.requestedDate).toISOString()
          : null,
        expeditionObs: obsChecked ? data?.expeditionObs : null,
        scienceStatus: scienceChecked ? Number(data?.scienceStatus?.id) : null
      }

      await mutateAsync(normalizedData)
    } catch {}

    setIsOpenModal(false)
  }

  const handleObsChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isValid = await trigger(`expeditionObs`)
    if (isValid) setObsChecked(!event.target.checked)
  }

  const handleDateChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isValid = await trigger(`deliveryDate`)
    if (isValid) setDateChecked(!event.target.checked)
  }

  const handleScienceChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isValid = await trigger(`scienceStatus`)
    if (isValid) setScienceChecked(!event.target.checked)
  }

  // const onSubmit = async (data: FormData) => {
  //   try {
  //     const normalizedData = {
  //       proposalId,
  //       deliveryDate: data?.deliveryDate
  //         ? new Date(data?.deliveryDate).toISOString()
  //         : null,
  //       expeditionObs: data?.expeditionObs,
  //       scienceStatus: Number(data?.scienceStatus?.id)
  //     }
  //     await mutateAsync(normalizedData)
  //     await turnOrder({
  //       proposalId
  //     })
  //     setIsOpenModal(false)
  //   } catch {}
  // }

  const onSubmitWithoutValidation = async (data: FormData) => {
    try {
      const normalizedData = {
        proposalId,
        deliveryDate: data?.deliveryDate
          ? new Date(data?.deliveryDate).toISOString()
          : null,
        requestedDate: data?.requestedDate
          ? new Date(data?.requestedDate).toISOString()
          : null,
        expeditionObs: data?.expeditionObs,
        scienceStatus: Number(data?.scienceStatus?.id)
      }

      await mutateAsync(normalizedData)
      await turnOrder({
        proposalId,
        validation: false
      })
      setIsOpenModal(false)
    } catch {}
  }

  useEffect(() => {
    if (orderData?.data) {
      reset({
        deliveryDate: orderData?.data?.deliveryDate
          ? getTimezonedIsoString(orderData?.data?.deliveryDate)
          : null,
        requestedDate: orderData?.data?.requestedDate
          ? getTimezonedIsoString(orderData?.data?.requestedDate)
          : null,
        expeditionObs: orderData?.data?.expeditionObs || '',
        scienceStatus: null,
        expeditionRequired: orderData?.data?.expeditionRequired || 0
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    orderData?.data?.deliveryDate,
    orderData?.data?.requestedDate,
    orderData?.data?.expeditionObs,
    reset
  ])

  return (
    <FormProvider {...methods}>
      <Modal
        open={isOpen}
        onClose={onClose}
        keepMounted={false}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <Card style={{ padding: 0, minWidth: 300, width: 800 }}>
          <CardHeader
            title={`Verificar Informações do orçamento ${proposalId || ''}`}
            HeaderRight={
              <IconButton onClick={() => onClose()}>
                <Close />
              </IconButton>
            }
          />
          <Divider />
          <CardContent>
            <FormGroup>
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <DatePickerC
                    name="deliveryDate"
                    label={`Previsão de Entrega`}
                    inputFormat="dd/MM/yyyy"
                    disabled={dateChecked}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControlLabel
                    label="Confirmar Data"
                    control={
                      <Checkbox
                        checked={dateChecked}
                        onChange={handleDateChange}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={8}>
                  <DatePickerC
                    name="requestedDate"
                    label={`Data Desejada`}
                    inputFormat="dd/MM/yyyy"
                  />
                </Grid>
                <Grid item xs={8}>
                  <TextFieldC
                    name="expeditionObs"
                    label="Observação de Entrega"
                    multiline
                    disabled={obsChecked}
                    rows={4}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControlLabel
                    label="Confirmar Observação"
                    control={
                      <Checkbox
                        checked={obsChecked}
                        onChange={handleObsChange}
                      />
                    }
                  />
                </Grid>

                <Grid item xs={8}>
                  <SelectC
                    name="scienceStatus"
                    disabled={scienceChecked}
                    options={[
                      {
                        id: '1',
                        name: 'SIM'
                      },
                      {
                        id: '0',
                        name: 'NÃO'
                      }
                    ]}
                    label="Cliente está ciente da descarga por sua conta?"
                    getOptionLabel={(option: any) => option?.name}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControlLabel
                    label="Confirmar Ciência"
                    control={
                      <Checkbox
                        checked={scienceChecked}
                        onChange={handleScienceChange}
                      />
                    }
                  />
                </Grid>
                {isSintegraError && (
                  <Grid item xs={12}>
                    <Alert severity="warning">
                      <AlertTitle>{sintegraError.message}</AlertTitle>
                      <div>
                        <Label>IE. Situação:</Label>{' '}
                        {sintegraError?.data?.statusStateRegistration}
                      </div>
                      <br />
                      <Label>Cadastrado no CIGAM:</Label>
                      <div>
                        <Label>Rua: </Label>
                        {sintegraError?.data?.district?.registred}{' '}
                        <Label>Nº: </Label>
                        {sintegraError?.data?.number?.registred}
                      </div>
                      <div>
                        <Label>Cidade: </Label>{' '}
                        {sintegraError?.data?.city?.registred}{' '}
                        <Label>UF:</Label>{' '}
                        {sintegraError?.data?.state?.registred}
                      </div>
                      <div>
                        <Label>IE.:</Label>{' '}
                        {sintegraError?.data?.registration?.registred}{' '}
                      </div>
                      <br />
                      <Label>Cadastrado Sintegra:</Label>
                      <div>
                        <Label>Rua: </Label>
                        {sintegraError?.data?.district?.compared}{' '}
                        <Label>Nº: </Label>
                        {sintegraError?.data?.number?.compared}
                      </div>
                      <div>
                        <Label>Cidade: </Label>{' '}
                        {sintegraError?.data?.city?.compared} <Label>UF:</Label>{' '}
                        {sintegraError?.data?.state?.compared}
                      </div>
                      <div>
                        <Label>IE.:</Label>{' '}
                        {sintegraError?.data?.registration?.compared}{' '}
                      </div>
                    </Alert>
                  </Grid>
                )}
              </Grid>
            </FormGroup>
          </CardContent>
          <Divider />
          <CardActions>
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                gap: '1rem'
              }}
            >
              <Button
                variant="text"
                sx={{
                  width: { sm: 100, md: 200 }
                }}
                onClick={() => onClose()}
              >
                Cancelar
              </Button>
              {/* <Button
                sx={{
                  width: { sm: 100, md: 200 },
                  display: user?.role !== 'ADM' && 'none'
                }}
                type="button"
                color="warning"
                loading={loadingTurnOrder}
                disabled={
                  isLoading ||
                  !obsChecked ||
                  !dateChecked ||
                  !scienceChecked ||
                  loadingTurnOrder
                }
                onClick={handleSubmit(onSubmitWithoutValidation)}
              >
                Transformar sem validar
              </Button> */}
              <Button
                sx={{
                  width: { sm: 100, md: 200 }
                }}
                type="button"
                loading={loadingTurnOrder}
                disabled={
                  isLoading ||
                  !obsChecked ||
                  !dateChecked ||
                  !scienceChecked ||
                  loadingTurnOrder
                }
                onClick={handleSubmit(onSubmitWithoutValidation)}
              >
                Transformar em pedido
              </Button>
            </div>
          </CardActions>
        </Card>
      </Modal>
    </FormProvider>
  )
}
